import React from 'react'
import { t } from 'ttag'

const ProfileSectionContact = ({ section }) => {
  if (section) {
    return (
      <div>
        {section.firstName && (
          <p>
            <b>{t`First Name:`}</b> {section.firstName}
          </p>
        )}
        {section.lastName && (
          <p>
            <b>{t`Last Name:`}</b> {section.lastName}
          </p>
        )}
        {section.email && (
          <p>
            <b>{t`E-Mail:`}</b> {section.email}
          </p>
        )}
        {section.phone && (
          <p>
            <b>{t`Phone:`}</b> {section.phone}
          </p>
        )}
        {section.position && (
          <p>
            <b>{t`Position:`}</b> {section.position}
          </p>
        )}
        {section.address && (
          <p>
            <b>{t`Address:`}</b> {section.address}
          </p>
        )}
        {section.city && (
          <p>
            <b>{t`City:`}</b> {section.city}
          </p>
        )}
        {section.state && (
          <p>
            <b>{t`State:`}</b> {section.state}
          </p>
        )}
        {section.zip && (
          <p>
            <b>{t`Zip:`}</b> {section.zip}
          </p>
        )}
        {section.notes && (
          <p>
            <b>{t`Notes:`}</b> {section.notes}
          </p>
        )}
      </div>
    )
  }

  return null
}

export default ProfileSectionContact
